import { Modal, Table } from "react-bootstrap";
import { formatSiteDateTime } from "../healthDateFilters";
import InvestigationStatusBadge from "./InvestigationStatusBadge";
import {
  formatInvestigationCost,
  InvestigationSession,
} from "./investigationSessions";

// Every past investigation session for the site, most recently active first.
// Clicking a row opens that session's thread.
const AllInvestigationsModal = ({
  siteName,
  sessions,
  timeZone,
  onSelect,
  onHide,
}: {
  siteName: string;
  sessions: InvestigationSession[];
  timeZone: string;
  onSelect: (sessionId: string) => void;
  onHide: () => void;
}) => (
  <Modal show onHide={onHide} size="xl" scrollable>
    <Modal.Header closeButton>
      <Modal.Title>{siteName} - AI investigations</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {sessions.length === 0 ? (
        <div className="text-muted">No investigations have been run yet.</div>
      ) : (
        <Table hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Question</th>
              <th>Last activity</th>
              <th>Status</th>
              <th className="text-end">Cost</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((session) => {
              const cost = formatInvestigationCost(session.costUsd);
              return (
                <tr
                  key={session.sessionId}
                  style={{ cursor: "pointer" }}
                  onClick={() => onSelect(session.sessionId)}
                >
                  <td>
                    {session.title}
                    {session.runs.length > 1 && (
                      <span className="text-muted small">
                        {" "}
                        ({session.runs.length} turns)
                      </span>
                    )}
                  </td>
                  <td className="text-nowrap">
                    {formatSiteDateTime(session.latestRun.createdAt, timeZone)}
                  </td>
                  <td>
                    <InvestigationStatusBadge
                      status={session.latestRun.status}
                    />
                  </td>
                  <td className="text-end text-nowrap">{cost ?? "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </Modal.Body>
  </Modal>
);

export default AllInvestigationsModal;
